const styles = theme => ({
  imageContainer: {
    width: 350,
    height: 350,
    backgroundColor: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: 1,
    transform: "scale(1)",
    transition: theme.transitions.create(["opacity", "transform"], {
      easing: theme.transitions.easing.sharp,
      duration: ".3s"
    })
  },
  image: {
    width: "90%"
  },
  imageHidden: {
    opacity: 0,
    transform: "scale(0)"
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Sponsor/styles.js